import React, { useState } from "react";
import { IMedia, LayoutCommonProps } from "../../../types";
import { LayoutHeader } from "../../layouts/LayoutHeader";
import RatingToast from "../../layouts/RatingToast";
import { MobileDetailModal } from "../MobileDetailModal";
import { MobileSeeAllModal } from "../MobileSeeAllModal";
import { truncateWords } from "../../../libs/utils";
import * as Styled from "./Layout1.styled";

export const Layout1: React.FC<LayoutCommonProps & { columns?: number }> = ({
    mediaItems,
    mediaRating,
    onWatchClick,
    onRatingSuccess,
    isSignedIn,
    sessionToken,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    playlistTitle,
    enableCompetitionMode,
    refreshMediaRatings,
    enableRatingControls,
    mediaPerPage,
    columns,
}) => {
    const [showToast, setShowToast] = useState(false);
    const [selectedItem, setSelectedItem] = useState<IMedia | null>(null);
    const [showSeeAll, setShowSeeAll] = useState(false);

    const handleRatingSuccessLocal = () => {
        setShowToast(true);
        onRatingSuccess();
        refreshMediaRatings?.();
    };

    const handleCardClick = (item: IMedia) => {
        setSelectedItem(item);
    };

    const handleCloseModal = () => {
        setSelectedItem(null);
    };

    const hasEligiblePlan = (item: IMedia) => {
        return (
            isSignedIn &&
            (!!item.planDetails.length
                ? !!activePlans.filter((memberPlan) =>
                      item.planDetails?.some(
                          (itemPlan) => itemPlan?.id === memberPlan.id
                      )
                  ).length ||
                  freeTrialPlanIds.includes(item.planDetails[0].id) ||
                  hasFullAccess
                : true)
        );
    };

    const displayItems = mediaPerPage
        ? mediaItems.slice(0, mediaPerPage)
        : mediaItems;

    if (!mediaItems.length) return null;

    return (
        <>
            <LayoutHeader
                title={playlistTitle}
                itemCount={mediaItems.length}
                onSeeAll={() => setShowSeeAll(true)}
                padding="20px 0px 20px 0px"
                marginTop="0px"
                isMobile={true}
            />

            <Styled.MobileGrid columns={columns}>
                {displayItems.map((item) => (
                    <Styled.MobileCardWrapper
                        key={item.id}
                        onClick={() => handleCardClick(item)}
                    >
                        <Styled.ThumbnailWrapper>
                            <img
                                src={item.thumbnail}
                                alt={item.title}
                            />
                        </Styled.ThumbnailWrapper>
                        <Styled.CardTitle>
                            {truncateWords(item.title, 30)}
                        </Styled.CardTitle>
                    </Styled.MobileCardWrapper>
                ))}
            </Styled.MobileGrid>

            {selectedItem && (
                <MobileDetailModal
                    isOpen={true}
                    onClose={handleCloseModal}
                    mediaItem={selectedItem}
                    mediaRating={mediaRating.find(
                        (_item) => _item.mediaId === selectedItem.mediaId
                    )}
                    enableRatingControls={enableRatingControls}
                    onWatchClick={(item) => {
                        handleCloseModal();
                        onWatchClick(item);
                    }}
                    onRatingSuccess={handleRatingSuccessLocal}
                    isSignedIn={isSignedIn}
                    hasEligiblePlan={hasEligiblePlan(selectedItem)}
                    sessionToken={sessionToken}
                    enableCompetitionMode={enableCompetitionMode}
                />
            )}

            <MobileSeeAllModal
                show={showSeeAll}
                onHide={() => setShowSeeAll(false)}
                title={playlistTitle}
                mediaItems={mediaItems}
                mediaRating={mediaRating}
                onWatchClick={onWatchClick}
                onRatingSuccess={handleRatingSuccessLocal}
                enableRatingControls={enableRatingControls}
                isSignedIn={isSignedIn}
                activePlans={activePlans}
                hasFullAccess={hasFullAccess}
                freeTrialPlanIds={freeTrialPlanIds}
                sessionToken={sessionToken}
                enableCompetitionMode={enableCompetitionMode}
                columns={columns}
            />

            <RatingToast show={showToast} onClose={() => setShowToast(false)} />
        </>
    );
};
